<template>
  <div class="body-container cooperation">
    <div class="banner"></div>
    <div class="text" id="text">{{detail.desc}}</div>
    <div class="box">
      <div class="box-title">成为姜子牙的合作伙伴</div>
      <img :src="detail.business_wx_qrcode" class="code-img" id="code2" />
      <div class="item wechat-no">
        <span>微信号：</span>
        <span id="wxNo2">{{detail.business_wx_no}}</span>
      </div>
      <div class="info-box">
        <div class="item">
          <span class="label">商务合作电话：</span>
          <a
            :href="`tel:${detail.business_tel}`"
            class="item-text"
            id="tel2"
          >{{detail.business_tel}}</a>
        </div>
        <div class="item">
          <span class="label">姜子牙客服热线：</span>
          <a :href="`tel:${detail.kf_tel}`" class="item-text" id="tel1">{{detail.kf_tel}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      detail: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    getInfo() {
      this.$http({
        type: "GET",
        url: "/api/mp/business/joinInfo"
      }).then(res => {
        this.detail = res.data;
      });
    }
  },
  created() {},
  mounted() {
    this.getInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "./cooperation.scss";
</style>